export const workspaceTemplateCs = {
  'workspace.events.title': 'Vaše události',
  'workspace.events.intro': 'Spravujte události vaší organizace. Připravujte je a otevírejte účastníkům.',
  'workspace.events.upcoming': 'Nejbližší událost',
  'workspace.events.other': 'Další události',
  'workspace.events.current': 'Poslední a připravované události',
  'workspace.events.selected': 'Vybraná událost',
  'workspace.events.select': 'Vybrat událost: {title}',
  'workspace.events.open': 'Otevřít událost',
  'workspace.events.empty': 'Nová setkání začínají zde',
  'workspace.events.emptyBody': 'Události vaší organizace se zobrazí v tomto přehledu.',
  'workspace.events.readOnly': 'Máte přístup pouze pro čtení. Události můžete prohlížet, ne měnit.',
  'workspace.events.dateMissing': 'Termín bude upřesněn',
  'workspace.events.locationMissing': 'Místo bude upřesněno',
  'workspace.events.lifecycle': 'Stav události',
  'workspace.events.preview': 'Náhled pracovní části — bez změny aktivního vzhledu a bez vzorových záznamů.',
  'workspace.actions': 'Pracovní nástroje',
  'workspace.settings': 'Nastavení',
  'workspace.poweredBy': 'Event od VCode',
} as const;

export const workspaceTemplateEn: Record<keyof typeof workspaceTemplateCs, string> = {
  'workspace.events.title': 'Your events',
  'workspace.events.intro': 'Manage your organization’s events. Prepare them and open them to attendees.',
  'workspace.events.upcoming': 'Next event',
  'workspace.events.other': 'More events',
  'workspace.events.current': 'Recent and planned events',
  'workspace.events.selected': 'Selected event',
  'workspace.events.select': 'Select event: {title}',
  'workspace.events.open': 'Open event',
  'workspace.events.empty': 'New gatherings start here',
  'workspace.events.emptyBody': 'Your organization’s events will appear in this overview.',
  'workspace.events.readOnly': 'You have read-only access. You can view events but cannot change them.',
  'workspace.events.dateMissing': 'Date to be confirmed',
  'workspace.events.locationMissing': 'Venue to be confirmed',
  'workspace.events.lifecycle': 'Event status',
  'workspace.events.preview': 'Workspace preview — no active theme changes and no sample records.',
  'workspace.actions': 'Workspace tools',
  'workspace.settings': 'Settings',
  'workspace.poweredBy': 'Event by VCode',
};
